















import Vue from 'vue';
import filesize from 'file-size';
import aviIcon from '@/assets/img/icon_avi.svg';
import docIcon from '@/assets/img/icon_doc.svg';
import docxIcon from '@/assets/img/icon_docx.svg';
import htmlIcon from '@/assets/img/icon_html.svg';
import jpgIcon from '@/assets/img/icon_jpg.svg';
import movIcon from '@/assets/img/icon_mov.svg';
import mp3Icon from '@/assets/img/icon_mp3.svg';
import mp4Icon from '@/assets/img/icon_mp4.svg';
import pdfIcon from '@/assets/img/icon_pdf.svg';
import pngIcon from '@/assets/img/icon_png.svg';
import pptIcon from '@/assets/img/icon_ppt.svg';
import rarIcon from '@/assets/img/icon_rar.svg';
import rawIcon from '@/assets/img/icon_raw.svg';
import wavIcon from '@/assets/img/icon_wav.svg';
import xlsIcon from '@/assets/img/icon_xls.svg';
import zipIcon from '@/assets/img/icon_zip.svg';
const FileIconMap: { [key: string]: { color: string; svg: string } } = {
    avi: {
        color: '#cf80b8',
        svg: 'aviIcon',
    },
    doc: {
        color: '#c1c1c1',
        svg: 'docIcon',
    },
    docx: {
        color: '#7090c4',
        svg: 'docxIcon',
    },
    html: {
        color: '#69b1b8',
        svg: 'htmlIcon',
    },
    jpg: {
        color: '#ab679c',
        svg: 'jpgIcon',
    },
    jpeg: {
        color: '#ab679c',
        svg: 'jpgIcon',
    },
    mov: {
        color: '#69abcf',
        svg: 'movIcon',
    },
    mp3: {
        color: '#6e998a',
        svg: 'mp3Icon',
    },
    mp4: {
        color: '#d47955',
        svg: 'mp4Icon',
    },
    pdf: {
        color: '#d9686e',
        svg: 'pdfIcon',
    },
    png: {
        color: '#6f8fa3',
        svg: 'pngIcon',
    },
    ppt: {
        color: '#ec8f49',
        svg: 'pptIcon',
    },
    pptx: {
        color: '#ec8f49',
        svg: 'pptIcon',
    },
    rar: {
        color: '#705662',
        svg: 'rarIcon',
    },
    raw: {
        color: '#e0b45a',
        svg: 'rawIcon',
    },
    wav: {
        color: '#a286c4',
        svg: 'wavIcon',
    },
    xls: {
        color: '#6bbf97',
        svg: 'xlsIcon',
    },
    xlsx: {
        color: '#6bbf97',
        svg: 'xlsIcon',
    },
    zip: {
        color: '#607582',
        svg: 'zipIcon',
    },
};
export default Vue.extend({
    components: {
        aviIcon,
        docIcon,
        docxIcon,
        htmlIcon,
        jpgIcon,
        movIcon,
        mp3Icon,
        mp4Icon,
        pdfIcon,
        pngIcon,
        pptIcon,
        rarIcon,
        rawIcon,
        wavIcon,
        xlsIcon,
        zipIcon,
    },
    props: {
        document: {
            type: Object,
            required: true,
        },
    },
    data: function() {
        return {
            hover: false,
        };
    },
    computed: {
        icon() {
            return FileIconMap[this.document.type?.toLowerCase()] || FileIconMap['doc'];
        },
        sizeString() {
            return filesize(this.document.size).human('si');
        },
    },
});
